// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.96.1/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.96.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.6.0/css/all.min.css);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  box-sizing: border-box;
}

html,
body {
  /* width: 100%; */
  /* height: 100%; */
  /* min-width: 100%; */
  /* min-height: 100%; */
  overflow-x: hidden;
}

body {
  display: block;
  /* flex-direction: column; */
  /* height: 100vh; */
  width: 100vw;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Noto Sans',
    Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji';
  margin: 0;
  padding: 0;
  text-align: center;
  background-color: #f8f8f8;
  overflow-x: hidden;
  color: #333;
  box-sizing: border-box;
}

.skip-to-content {
  position: absolute;
  top: -40px;
  left: 0;
  background: #c0392b;
  color: #ecf0f1;
  padding: 8px;
  z-index: 100;
  transition: top 0.3s;
}

.skip-to-content:focus {
  top: 0;
}

app-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 10px;
  background-color: #2c3e50;
  color: #ecf0f1;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
}

app-bar h1 {
  margin: 0;
  font-size: 24px;
}

app-bar h1 a {
  color: #ecf0f1;
  text-decoration: none;
  padding: 0 20px;
  display: inline-block;
  line-height: 60px;
}

nav a {
  display: inline-block;
  line-height: 60px;
  padding: 0 20px;
  text-decoration: none;
  color: #ecf0f1;
  font-size: 18px;
  min-width: 44px;
  min-height: 44px;
}

.menu-btn,
.close-btn {
  display: none;
  font-size: 24px;
  cursor: pointer;
  background: transparent;
  border: 0;
  color: #ecf0f1;
  width: 60px;
  height: 60px;
}

app-bar a:hover,
app-bar button:hover {
  color: #fff;
}

#content {
  /* flex: 1;
  overflow-y: auto; */
  /* flex-grow: 1; */
  min-height: calc(100vh - 142px);
}

.hero {
  width: 100%;
  height: 400px;
  position: relative;
  overflow: hidden;
  /* background-image: url('../public/images/heros/hero-image_4.jpg');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat; */
}

.hero img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  transition: opacity 1s ease-in-out;
}

.hero img.active {
  opacity: 1;
}

.hero .caption {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #ecf0f1;
  font-size: 48px;
  text-shadow: 2px 2px 4px #000;
  width: 100%;
}

.hero .caption .btn {
  font-family:
    system-ui,
    -apple-system,
    BlinkMacSystemFont,
    'Segoe UI',
    Roboto,
    Oxygen,
    Ubuntu,
    Cantarell,
    'Open Sans',
    'Helvetica Neue',
    sans-serif;
  display: inline-block;
  margin-top: 20px;
  padding: 10px 20px;
  font-size: 16px;
  color: white;
  background-color: #2c3e50;
  border: none;
  border-radius: 5px;
  text-decoration: none;
  text-align: center;
  transition:
    background-color 0.3s,
    transform 0.2s;
}

.hero .caption .btn:hover {
  background-color: #233241;
  transform: translateY(-2px);
}

main h2 {
  margin-bottom: 40px;
  font-size: 32px;
  color: #2c3e50;
}

main .explore {
  padding: 20px;
}

.cards {
  display: flex;
  justify-content: center;
  gap: 20px;
  flex-wrap: wrap;
}

.card {
  border: 1px solid #ddd;
  border-radius: 8px;
  width: 350px;
  padding: 20px;
  text-align: left;
  background-color: #fff;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  transition:
    transform 0.2s,
    opacity 0.5s ease-in-out;
  position: relative;
  text-decoration: none;
  opacity: 0;
}

.card.show {
  opacity: 1;
}

.card.show:hover {
  transform: scale(1.05);
}

.card img {
  width: 100%;
  height: 200px;
  border-radius: 8px;
  object-fit: cover;
}

.card .location {
  background-color: #c0392b;
  color: #fff;
  padding: 5px 10px;
  border-radius: 8px 0;
  position: absolute;
  top: 20px;
  left: 20px;
  z-index: 1;
}

.card .rating {
  margin: 10px 0 0 0;
}

.card .rating i {
  color: #f1c40f;
}

.card h3 {
  margin: 0;
}

.card h3 a {
  color: #2c3e50;
  text-decoration: none;
  display: block;
  line-height: 50px;
}

.card p {
  color: #7f8c8d;
  margin: 0;
  overflow: hidden;
}

.loading {
  font-size: 24px;
  color: #2c3e50;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.spinner {
  border: 4px solid #f3f3f3;
  border-top: 4px solid #2c3e50;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

footer {
  margin: 0;
  /* margin-top: 30px; */
  padding: 20px;
  background-color: #2c3e50;
  color: #ecf0f1;
  border-top: 1px solid #000;
  width: 100vw;
  height: 61px;
  /* height: 61px; */
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
  display: none;
}

/* Restaurant Detail */
restaurant-detail {
  display: flex;
  flex-direction: column;
  margin: auto;
  max-width: 800px;
  text-align: justify;
  padding: 20px;
  min-height: 100vh;
}

restaurant-detail h1 {
  font-size: 40px;
  margin: 24px 0;
}

restaurant-detail h2 {
  font-size: 32px;
  margin: 16px 0;
}

restaurant-detail h3 {
  font-size: 24px;
  margin: 8px 0;
}

.restaurant-info {
  display: flex;
  flex-direction: row;
  gap: 16px;
  margin-bottom: 24px;
}

.restaurant-image {
  height: 200px;
  width: 100%;
  border-radius: 10px;
  object-fit: cover;
  margin: 30px 0 0 0;
}

.restaurant-info .rating {
  margin-top: -16px;
  margin-bottom: 16px;
}

.restaurant-info .rating .fas,
.restaurant-info .rating .far {
  color: #f1c40f;
  font-size: 18px;
}

.restaurant-info .fa,
.restaurant-info .far,
.restaurant-info .fas {
  width: 24px;
}

.restaurant-info .location {
  margin-bottom: 14px;
}

.restaurant-info .category {
  margin-bottom: 14px;
}

.favorite-button {
  color: #333;
  text-align: left;
  padding: 0;
  font-size: 16px;
  cursor: pointer;
  background-color: transparent;
  border: none;
  text-decoration: none;
  min-height: 50px;
  min-width: 50px;
}
.favorite-button.active {
  color: red;
}
.favorite-button:hover {
  transform: translateY(-1px);
}

.review {
  display: flex;
  margin-bottom: 20px;
}

.review .avatar {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  margin-right: 10px;
  flex-shrink: 0;
  background-color: #2c3e50;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  font-weight: 600;
}

.review .content h4 {
  margin: 0;
  font-size: 16px;
}

.review .content .date {
  font-size: 14px;
  color: #666;
  margin-bottom: 10px;
}

.review-form {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 32px;
}

.review-form input[type='text'],
.review-form textarea {
  box-sizing: border-box;
  width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Noto Sans',
    Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji';
}

.review-form input {
  min-height: 44px;
}

.review-form textarea {
  min-height: 120px;
}

.review-form button {
  background-color: #2c3e50;
  color: white;
  border: none;
  padding: 15px;
  border-radius: 4px;
  cursor: pointer;
  width: 100%;
}

@media (max-width: 768px) {
  /* .restaurant-info {
    flex-direction: column;
  } */

  .hero {
    height: 300px;
  }

  .restaurant-image {
    max-width: 160px;
  }

  .menu-btn {
    display: block;
  }

  .close-btn {
    display: inline-block;
    width: 100%;
    padding: 15px 20px;
    border-bottom: 1px solid #34495e;
  }

  nav {
    display: flex;
    flex-direction: column;
    position: fixed;
    top: 0;
    right: -250px;
    background-color: #2c3e50;
    width: 250px;
    height: 100%;
    transition: right 0.3s;
    z-index: 1000;
    visibility: hidden;
  }

  nav a {
    border-bottom: 1px solid #34495e;
    color: #ecf0f1;
  }

  nav a:last-child {
    border-bottom: none;
  }

  .menu-btn.active + nav {
    right: 0;
    visibility: visible;
  }

  .cards {
    flex-direction: column;
    align-items: center;
  }

  .card {
    width: 90%;
  }

  .overlay.active {
    display: block;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/main.css"],"names":[],"mappings":"AAEA;EACE,sBAAsB;AACxB;;AAEA;;EAEE,iBAAiB;EACjB,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,4BAA4B;EAC5B,mBAAmB;EACnB,YAAY;EACZ;uEACqE;EACrE,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,OAAO;EACP,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,MAAM;AACR;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,cAAc;EACd,6CAA6C;AAC/C;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,eAAe;EACf,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,eAAe;EACf,eAAe;EACf,uBAAuB;EACvB,SAAS;EACT,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE;qBACmB;EACnB,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB;;;iCAG+B;AACjC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,UAAU;EACV,kCAAkC;AACpC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,cAAc;EACd,eAAe;EACf,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE;;;;;;;;;;;cAWY;EACZ,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB;;kBAEgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,sBAAsB;EACtB,wCAAwC;EACxC;;4BAE0B;EAC1B,kBAAkB;EAClB,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kCAAkC;AACpC;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,SAAS;EACT,sBAAsB;EACtB,aAAa;EACb,yBAAyB;EACzB,cAAc;EACd,0BAA0B;EAC1B,YAAY;EACZ,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,YAAY;EACZ,aAAa;AACf;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;EACd,eAAe;AACjB;;AAEA;;;EAGE,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,UAAU;EACV,eAAe;EACf,eAAe;EACf,6BAA6B;EAC7B,YAAY;EACZ,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,UAAU;AACZ;AACA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;;EAEE,sBAAsB;EACtB,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB;uEACqE;AACvE;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA;EACE;;KAEG;;EAEH;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,qBAAqB;IACrB,WAAW;IACX,kBAAkB;IAClB,gCAAgC;EAClC;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,MAAM;IACN,aAAa;IACb,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,sBAAsB;IACtB,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,gCAAgC;IAChC,cAAc;EAChB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,QAAQ;IACR,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,cAAc;EAChB;AACF","sourcesContent":["@import url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.6.0/css/all.min.css');\n\n* {\n  box-sizing: border-box;\n}\n\nhtml,\nbody {\n  /* width: 100%; */\n  /* height: 100%; */\n  /* min-width: 100%; */\n  /* min-height: 100%; */\n  overflow-x: hidden;\n}\n\nbody {\n  display: block;\n  /* flex-direction: column; */\n  /* height: 100vh; */\n  width: 100vw;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Noto Sans',\n    Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji';\n  margin: 0;\n  padding: 0;\n  text-align: center;\n  background-color: #f8f8f8;\n  overflow-x: hidden;\n  color: #333;\n  box-sizing: border-box;\n}\n\n.skip-to-content {\n  position: absolute;\n  top: -40px;\n  left: 0;\n  background: #c0392b;\n  color: #ecf0f1;\n  padding: 8px;\n  z-index: 100;\n  transition: top 0.3s;\n}\n\n.skip-to-content:focus {\n  top: 0;\n}\n\napp-bar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0 10px;\n  background-color: #2c3e50;\n  color: #ecf0f1;\n  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);\n}\n\napp-bar h1 {\n  margin: 0;\n  font-size: 24px;\n}\n\napp-bar h1 a {\n  color: #ecf0f1;\n  text-decoration: none;\n  padding: 0 20px;\n  display: inline-block;\n  line-height: 60px;\n}\n\nnav a {\n  display: inline-block;\n  line-height: 60px;\n  padding: 0 20px;\n  text-decoration: none;\n  color: #ecf0f1;\n  font-size: 18px;\n  min-width: 44px;\n  min-height: 44px;\n}\n\n.menu-btn,\n.close-btn {\n  display: none;\n  font-size: 24px;\n  cursor: pointer;\n  background: transparent;\n  border: 0;\n  color: #ecf0f1;\n  width: 60px;\n  height: 60px;\n}\n\napp-bar a:hover,\napp-bar button:hover {\n  color: #fff;\n}\n\n#content {\n  /* flex: 1;\n  overflow-y: auto; */\n  /* flex-grow: 1; */\n  min-height: calc(100vh - 142px);\n}\n\n.hero {\n  width: 100%;\n  height: 400px;\n  position: relative;\n  overflow: hidden;\n  /* background-image: url('../public/images/heros/hero-image_4.jpg');\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat; */\n}\n\n.hero img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  position: absolute;\n  top: 0;\n  left: 0;\n  opacity: 0;\n  transition: opacity 1s ease-in-out;\n}\n\n.hero img.active {\n  opacity: 1;\n}\n\n.hero .caption {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  color: #ecf0f1;\n  font-size: 48px;\n  text-shadow: 2px 2px 4px #000;\n  width: 100%;\n}\n\n.hero .caption .btn {\n  font-family:\n    system-ui,\n    -apple-system,\n    BlinkMacSystemFont,\n    'Segoe UI',\n    Roboto,\n    Oxygen,\n    Ubuntu,\n    Cantarell,\n    'Open Sans',\n    'Helvetica Neue',\n    sans-serif;\n  display: inline-block;\n  margin-top: 20px;\n  padding: 10px 20px;\n  font-size: 16px;\n  color: white;\n  background-color: #2c3e50;\n  border: none;\n  border-radius: 5px;\n  text-decoration: none;\n  text-align: center;\n  transition:\n    background-color 0.3s,\n    transform 0.2s;\n}\n\n.hero .caption .btn:hover {\n  background-color: #233241;\n  transform: translateY(-2px);\n}\n\nmain h2 {\n  margin-bottom: 40px;\n  font-size: 32px;\n  color: #2c3e50;\n}\n\nmain .explore {\n  padding: 20px;\n}\n\n.cards {\n  display: flex;\n  justify-content: center;\n  gap: 20px;\n  flex-wrap: wrap;\n}\n\n.card {\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  width: 350px;\n  padding: 20px;\n  text-align: left;\n  background-color: #fff;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  transition:\n    transform 0.2s,\n    opacity 0.5s ease-in-out;\n  position: relative;\n  text-decoration: none;\n  opacity: 0;\n}\n\n.card.show {\n  opacity: 1;\n}\n\n.card.show:hover {\n  transform: scale(1.05);\n}\n\n.card img {\n  width: 100%;\n  height: 200px;\n  border-radius: 8px;\n  object-fit: cover;\n}\n\n.card .location {\n  background-color: #c0392b;\n  color: #fff;\n  padding: 5px 10px;\n  border-radius: 8px 0;\n  position: absolute;\n  top: 20px;\n  left: 20px;\n  z-index: 1;\n}\n\n.card .rating {\n  margin: 10px 0 0 0;\n}\n\n.card .rating i {\n  color: #f1c40f;\n}\n\n.card h3 {\n  margin: 0;\n}\n\n.card h3 a {\n  color: #2c3e50;\n  text-decoration: none;\n  display: block;\n  line-height: 50px;\n}\n\n.card p {\n  color: #7f8c8d;\n  margin: 0;\n  overflow: hidden;\n}\n\n.loading {\n  font-size: 24px;\n  color: #2c3e50;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n}\n\n.spinner {\n  border: 4px solid #f3f3f3;\n  border-top: 4px solid #2c3e50;\n  border-radius: 50%;\n  width: 24px;\n  height: 24px;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\nfooter {\n  margin: 0;\n  /* margin-top: 30px; */\n  padding: 20px;\n  background-color: #2c3e50;\n  color: #ecf0f1;\n  border-top: 1px solid #000;\n  width: 100vw;\n  height: 61px;\n  /* height: 61px; */\n}\n\n.overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  z-index: 999;\n  display: none;\n}\n\n/* Restaurant Detail */\nrestaurant-detail {\n  display: flex;\n  flex-direction: column;\n  margin: auto;\n  max-width: 800px;\n  text-align: justify;\n  padding: 20px;\n  min-height: 100vh;\n}\n\nrestaurant-detail h1 {\n  font-size: 40px;\n  margin: 24px 0;\n}\n\nrestaurant-detail h2 {\n  font-size: 32px;\n  margin: 16px 0;\n}\n\nrestaurant-detail h3 {\n  font-size: 24px;\n  margin: 8px 0;\n}\n\n.restaurant-info {\n  display: flex;\n  flex-direction: row;\n  gap: 16px;\n  margin-bottom: 24px;\n}\n\n.restaurant-image {\n  height: 200px;\n  width: 100%;\n  border-radius: 10px;\n  object-fit: cover;\n  margin: 30px 0 0 0;\n}\n\n.restaurant-info .rating {\n  margin-top: -16px;\n  margin-bottom: 16px;\n}\n\n.restaurant-info .rating .fas,\n.restaurant-info .rating .far {\n  color: #f1c40f;\n  font-size: 18px;\n}\n\n.restaurant-info .fa,\n.restaurant-info .far,\n.restaurant-info .fas {\n  width: 24px;\n}\n\n.restaurant-info .location {\n  margin-bottom: 14px;\n}\n\n.restaurant-info .category {\n  margin-bottom: 14px;\n}\n\n.favorite-button {\n  color: #333;\n  text-align: left;\n  padding: 0;\n  font-size: 16px;\n  cursor: pointer;\n  background-color: transparent;\n  border: none;\n  text-decoration: none;\n  min-height: 50px;\n  min-width: 50px;\n}\n.favorite-button.active {\n  color: red;\n}\n.favorite-button:hover {\n  transform: translateY(-1px);\n}\n\n.review {\n  display: flex;\n  margin-bottom: 20px;\n}\n\n.review .avatar {\n  width: 50px;\n  height: 50px;\n  border-radius: 50%;\n  margin-right: 10px;\n  flex-shrink: 0;\n  background-color: #2c3e50;\n  color: white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 20px;\n  font-weight: 600;\n}\n\n.review .content h4 {\n  margin: 0;\n  font-size: 16px;\n}\n\n.review .content .date {\n  font-size: 14px;\n  color: #666;\n  margin-bottom: 10px;\n}\n\n.review-form {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  margin-bottom: 32px;\n}\n\n.review-form input[type='text'],\n.review-form textarea {\n  box-sizing: border-box;\n  width: 100%;\n  padding: 10px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Noto Sans',\n    Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji';\n}\n\n.review-form input {\n  min-height: 44px;\n}\n\n.review-form textarea {\n  min-height: 120px;\n}\n\n.review-form button {\n  background-color: #2c3e50;\n  color: white;\n  border: none;\n  padding: 15px;\n  border-radius: 4px;\n  cursor: pointer;\n  width: 100%;\n}\n\n@media (max-width: 768px) {\n  /* .restaurant-info {\n    flex-direction: column;\n  } */\n\n  .hero {\n    height: 300px;\n  }\n\n  .restaurant-image {\n    max-width: 160px;\n  }\n\n  .menu-btn {\n    display: block;\n  }\n\n  .close-btn {\n    display: inline-block;\n    width: 100%;\n    padding: 15px 20px;\n    border-bottom: 1px solid #34495e;\n  }\n\n  nav {\n    display: flex;\n    flex-direction: column;\n    position: fixed;\n    top: 0;\n    right: -250px;\n    background-color: #2c3e50;\n    width: 250px;\n    height: 100%;\n    transition: right 0.3s;\n    z-index: 1000;\n    visibility: hidden;\n  }\n\n  nav a {\n    border-bottom: 1px solid #34495e;\n    color: #ecf0f1;\n  }\n\n  nav a:last-child {\n    border-bottom: none;\n  }\n\n  .menu-btn.active + nav {\n    right: 0;\n    visibility: visible;\n  }\n\n  .cards {\n    flex-direction: column;\n    align-items: center;\n  }\n\n  .card {\n    width: 90%;\n  }\n\n  .overlay.active {\n    display: block;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
